<template>
  <div class="bg_gray">
    <div class="fixed">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon
              name="arrow-left"
              class="mar_r"
              @click="goback"
              size="0.4rem"
            />
            <div class="search_con m_flex_box flex_vc">入网企业</div>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed_pad"></div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="no_data" v-if="!list.length">
          <img src="@/assets/img/nodata.png" alt="" />
        </div>
        <div class="inner bor_b" v-for="(item, index) in list" :key="index">
          <div class="row">
            <p class="m_flex_box">
              企业名称：<span>{{ item.corpName ? item.corpName : "-" }}</span>
            </p>
          </div>
          <div class="row">
            <p class="m_flex_box">
              企业地址：<span>{{
                item.corpAddress ? item.corpAddress : "-"
              }}</span>
            </p>
          </div>
          <div class="row">
            <p class="m_flex_box">
              营业执照注册号：<span>{{ item.liCode ? item.liCode : "-" }}</span>
            </p>
          </div>
          <div class="row">
            <p class="m_flex_box">
              入网区域：<span>{{
                parseInt(item.corpRemark) != 0
                  ? areaList[parseInt(item.corpRemark) - 1]
                  : areaList[0]
              }}</span>
            </p>
          </div>
          <div class="row">
            <p class="m_flex_box">
              入网日期：<span>{{
                item.createDate ? item.createDate : "-"
              }}</span>
            </p>
          </div>
          <div class="btn">
            <van-button block type="small" color="#007fff" @click="submit(item)">我要变更</van-button>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <!-- <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="xzqh_name"
        :columns="xzqhArray"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup> -->
  </div>
</template>

<script>
import topHeader from "@/components/header";
import qs from "qs";
export default {
  data() {
    return {
      areaList: [
        "市区",
        "贾汪",
        "睢宁",
        "邳州",
        "沛县",
        "丰县",
        "铜山",
        "新沂",
        "高新",
      ],
      isLoading: false,
      loading: false,
      finished: false,
      list: [],
      currPageNo: 1,
      timer: null,
      itemName: "",
      showPicker: false,
      xzqhArray: [],
      xzqhDefault: this.main.getHostArea(),
      items: "",
      area: "",
      corpName: this.$route.query.codeName,
    };
  },
  mounted() {},
  methods: {
    goback() {
      this.$router.go(-1);
    },
    submit(item) {
      this.$router.push({
        path: "/changeType",
        query: {
          corpCode: item.corpCode,
          corpName: item.corpName,
        },
      });
    },
    onRefresh() {
      this.loading = true;
      this.finished = false;
      this.currPageNo = 1;
      this.$set(this, "list", []);
      this.onLoad(1);
    },
    onConfirm(data) {
      this.area = data.xzqh_name;
      this.showPicker = false;
      this.$set(this, "xzqh", data.xzqh_code);
      this.loading = false;
      this.finished = false;
      this.currPageNo = 1;
      this.$set(this, "list", []);
      this.onLoad();
    },
    onLoad(type) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50);
        this.$test
          .post(
            "spf/corpinfo/getByCorpName",
            qs.stringify({
              corpName: this.corpName,
            }),
            {
              headers: {
                xzfpftoken: sessionStorage.getItem("userId") || "",
              }
            }
          )
          .then((res) => {
            if (type) {
              this.isLoading = false;
            }
            if (res.code == "000") {
              this.list = this.list.concat(res.result);
              this.loading = false;
              this.finished = true;
              // this.$set(this, "currPageNo", this.currPageNo + 1);
            } else if (res.code == "003") {
              this.$router.replace({
                path: "/enterpriseAccess",
              });
            }
          });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.fixed_pad {
  padding-top: 1.1rem;
}
.fixed {
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  .top_normal {
    height: 100%;
    i {
      font-size: 0.32rem;
    }
  }
}
// .header_address {
//   padding: 0.1rem 0.2rem;
//   border-radius: 0.1rem;
//   background: #ccc;
//   font-size: 0.28rem;
//   font-weight: 600;
//   cursor: pointer;
//   &.white {
//     &:after {
//       border-color: #fff transparent transparent transparent;
//     }
//   }
// }
.top_header {
  height: 0.7rem;
  padding: 0.1rem 0rem;
  width: 7.04rem;
  margin: 0 auto;
  &.top_sm {
    padding: 0.1rem;
  }
  .search_con,
  .search_con_l {
    height: 0.7rem;
    box-sizing: border-box;
    font-size: 0.3rem;
    padding: 0 0.3rem;
    color: #303030;
    i {
      font-size: 0.36rem;
      margin-right: 0.2rem;
    }
  }
  input {
    width: 80%;
    height: 0.7rem;
    background-color: transparent;
  }
  .search_con {
    font-weight: bolder;
    justify-content: center;
    width: 5.78rem;
  }
  .search_con_l {
    width: 5.72rem;
  }
  .to_map {
    font-size: 0.28rem;
    img {
      margin-right: 0.06rem;
      width: 0.32rem;
      height: 0.32rem;
    }
  }
}
.bg_gray {
  min-height: 100vh;
  background-color: #f5f5f5;
}
.inner {
  padding: 0.24rem 0.24rem;
  background-color: #fff;
}
.top {
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 0.2rem;
  margin-bottom: 0.12rem;
  h5 {
    font-size: 0.26rem;
    font-weight: 800;
    max-width: 70%;
  }
  p {
    font-size: 0.24rem;
    span {
      color: #2f72f5;
    }
  }
}
.btn {
  width: 3.5rem;
  margin: 0 auto;
  padding-top: 0.5rem;
}
.row {
  &:last-child {
    padding-bottom: 0;
  }
  padding-bottom: 0.12rem;
  p {
    line-height: 0.36rem;
    color: #808080;
    font-size: 0.24rem;
    span {
      max-width: 70%;
      color: #101010;
    }
  }
}
.bor_b {
  border-bottom: 0.1rem solid #f5f5f5;
}
</style>